import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewChildren, HostListener, ElementRef } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { MatDialogRef, MatDialog, MatSelect, MatDatepickerInputEvent, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { NgForm } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { AutocompleteComponent } from 'src/app/shared/components/autocomplete/autocomplete.component';
import { Observable, fromEvent } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { DepartmentService } from 'src/app/core/services/department.service';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { Common, DateFormat } from 'src/app/core/constants/common';
import { SmsWarningComponent } from 'src/app/shared/components/sms-warning/sms-warning.component';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { Platform } from '@angular/cdk/platform';
import { MY_FORMATS } from 'src/app/app.component';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AddUserComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  UNDERSCORE = '_';
  user = {
    tenantId: localStorage.getItem('tenantId'),
    userName: '',
    fullName: '',
    userType: '2',
    enterpriseId: localStorage.getItem('enterpriseId'),
    phone: '',
    email: '',
    description: '',
    departmentId: null,
    permissions: [],
    isSmsSend:false,
    certificateId: null,
    certificateNo: '',
    userPosition: '',
    nationality: '',
    livingAddress: '',
    address: '',
    idIssuePlace: '',
    birthday: null,
    idIssueDate: null,
  };
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);
  // the value used to store previous username, which input by user
  usernamePrev = '';
  usernamePrefix = '';
  enterpriseAccount = '';
  enterprises: [];
  enterpriseInfor : any;
  listDepartment = [];
  listCertificate = [];
  listCertificateFilter = [];
  listDepartmentFilter = [];
  userId: '';
  checkFocus = true;
  selectedIndex = -1;
  returnSelectedIndex = -1;
  dataList = new Array();
  selectedList = new Array();
  // Variable for saving original data list
  originalDataList = [];
  // Variable for saving original selected list
  originalSelectedList = [];
  // Variable for binding search feature words
  filterWords = '';
  filterWordsSelected = '';

  // Check if current user is a regular user (userType=2) — restrict user_type field
  currentUserType: number = Number(localStorage.getItem('userType'));
  isUserTypeRestricted: boolean = this.currentUserType === 2;

  leftList = new Array();
  rightList = new Array();
  enterpriseId: string = "";

  // List all parent branches
  parentBranches: { id: string, name: '' }[];
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };
  @ViewChild(AutocompleteComponent, { read: AutocompleteComponent, static: true }) autocompleteComponent;
  @ViewChild('userTypeSelect', { static: false }) userTypeSelect: MatSelect;
  @ViewChild('usernameRef', { static: false }) usernameRef: ElementRef;
  usernameRef$: Observable<any>;
  usernameRefSubscription: Subscription;

  addUrl = '/users/user-enterprise';

  // check to alow create muti user or not
  isMultiCreateUser = false;
  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  checkEscKey = false;
  phonePattern = Common.PHONE_PATTERN2;
  phoneMaxlength = Common.MAX_LENGTH_PHONE;
  @ViewChildren('focusInput') focusInput;
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.onNoClick();
    }
  }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }
  /**
   * Index check form dirty
   */
  indexFormDirty = 0;

  constructor(
    private el: ElementRef,
    private usService: UserService,
    public dialogRef: MatDialogRef<AddUserComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private apiService: ApiService,
    private departmentService: DepartmentService,
    private enterpriseService: EnterpriseService,
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onNoClick();
    });
  }

  ngOnInit() {
    if (this.isUserTypeRestricted) {
      this.user.userType = '2';
    }
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.getParentBranches();
    this.getDepartments();
    this.apiService.addUrlToHandlingErrorRestApis(this.addUrl);
    this.getRepresentativeCertificateType();
    this.loadData(this.enterpriseId)
  }
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        const result = rs.data;
        this.listCertificate = result;
        this.listCertificateFilter = this.listCertificate;
      }
    });
  }

  ngAfterViewInit() {
    this.usernameRef$ = fromEvent(this.usernameRef.nativeElement, 'input');
    this.usernameRefSubscription = this.usernameRef$.subscribe(e => this.onUsernameChange(e));

    setTimeout(_ => this.focusInput.first.nativeElement.focus());

    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.indexFormDirty = this.indexFormDirty + 1;
        if (this.indexFormDirty > 3) {
          this.isFormChanging = true;
        }
      }
    });
  }


  loadData(enterpriseId: string) {
    this.enterpriseService.getEnterpriseByID(enterpriseId).subscribe(rs => {
      if (rs != null && rs.data != null) {
        const responsedData = rs.data;
        this.enterpriseInfor = responsedData;
        if(this.enterpriseInfor.taxCode == ""){
        this.user.userName = this.enterpriseInfor.certificateNo + "_";
      }else{
        this.user.userName = this.enterpriseInfor.taxCode + "_";
      }

      }
    });
  }

  onUsernameChange(e) {
    const val: string = e.target.value;
    if (val.length <= 0 || (val && !val.startsWith(this.usernamePrefix))) {
      this.user.userName = this.usernamePrefix;
    }
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    // this.change = true;
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    if (this.usernameRefSubscription) {
      this.usernameRefSubscription.unsubscribe();
    }
    this.apiService.removeUrlToHandlingErrorRestApis();
  }

  /**
   * Get account of the enterprise which current user is belong to
   * @param enterpriseId: string
   */
  getEnterpriseAccount(enterpriseId: string) {
    this.usService.getEnterpriseAccount(enterpriseId)
      .subscribe(rs => {
        if (rs.data != null) {
          this.enterpriseAccount = rs.data;
          this.usernamePrefix = this.enterpriseAccount + '_';
          this.user.userName = this.usernamePrefix;
          this.usernamePrev = this.user.userName;
        }
      });
  }

  onCreateUser() {
    let regexpNumber = new RegExp(this.phonePattern);
    if (!regexpNumber.test(this.user.phone.trim())) {
      this.toastr.error(this.message.getMessage('validation.phone_number_10_or_11_invalid_format'));
      return;
    }
    const permissions = new Array();
    const userName = this.user.userName;
    for (const permission of this.selectedList) {
      permissions.push(permission.id);
    }
    this.usService.addUserEnterprise({
      ...this.user,
      userName,
      permissions,
      userType: Number(this.user.userType)
    },
      this.onAddUserError.bind(this)
    ).subscribe(rs => {
      console.log(rs);
      if (rs.success) {
        this.toastr.success(this.commonService.format(this.message.getMessage('messages.add_user_success'), userName));
        if (this.isMultiCreateUser) {
          this.returnAllClick();
          this.ngForm.resetForm({ "userType": '2' });
          setTimeout(_ => { this.focusInput.first.nativeElement.focus(); this.user.userName = this.usernamePrefix; });
          this.isFormChanging = false;
        } else {
          this.dialogRef.close();
        }
      } else {
        if (rs.code) {
           this.toastr.error(rs.message);
           this.user.departmentId = null;
           this.getDepartments();
        }
      }
    });
  }

  private onAddUserError(rs: any) {
    if (!rs.success) {
      if (rs.code == "0x00707") {
        this.ngForm.form.controls.userName.setErrors({ duplicate: true });
        document.getElementById("userName").focus();
      }else if (rs.code == "0x010093"){
        this.smsWarningHandler()
      }
    }
  }

  private smsWarningHandler(): void{
    const dialogRe = this.dialog.open(SmsWarningComponent, {
      width: '500px',
      data: this.message.getMessage('messages.sms_warning_user')
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.user ={...this.user,isSmsSend:false};
        this.onCreateUser()
      }else{
        dialogRe.close();
      }
    });
  }

  /**
   * Grant peermission for user
   * @param userId: any
   */
  onAddPermision(userId: any) {
    let i;
    const featureGroupIds = new Array();
    for (i = 0; i < this.selectedList.length; i++) {
      featureGroupIds.push(this.selectedList[i].id);
    }
    const request = {
      userId,
      featureGroupIds
    };
    this.usService.grantPermmision(request).subscribe(
      () => {
        this.dialogRef.close();
      }, () => {
      }
    );
  }

  /**
   * Get parent branches for creating branch
   */
  getParentBranches() {
    this.usService.getAllChild(
      this.user.enterpriseId
    ).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.parentBranches = rs.data;
      this.selectedBranch = this.parentBranches.find(x => {
        return x.id === this.user.enterpriseId;
      });
      this.autocompleteComponent.formControl.setValue({ id: this.selectedBranch.id, name: this.selectedBranch.name });
    });
  }

  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompleted() {
    if (this.selectedBranch == null || this.selectedBranch == undefined || this.selectedBranch.name.trim().length === 0) {
      this.user.enterpriseId = '';
      this.enterpriseAccount = '';
      this.dataList = [];
      this.originalDataList = this.dataList;
    } else if (this.selectedBranch != null && this.selectedBranch != undefined || this.selectedBranch.name.trim().length === 0) {
      this.ngForm.control.markAsDirty();
      this.user.enterpriseId = this.selectedBranch.id;
      this.getEnterpriseAccount(this.user.enterpriseId);
      this.getDepartmentByEnterpriseId(this.user.enterpriseId);
      this.usService.getFeatureList(this.user.enterpriseId).subscribe(res => {
        if (res == null || res.data == null) {
          return 0;
        }
        this.dataList = res.data;
        this.originalDataList = this.dataList;
      }, error => {
        console.log(error);
      });
    }
  }

  onFilterFeatures() {
    const filterWords = this.filterWords.toLowerCase().trim();
    // Get new dataList according to filterWords
    this.dataList = this.originalDataList.filter((dataPermission) => {
      return this.commonService.checkFilterWords(dataPermission.name.toLowerCase(), filterWords);
    });
    // Remove items which are exist in this.selectedList
    this.dataList = this.dataList.filter(dataListPermission => {
      let found = false;
      for (let i = 0; i < this.selectedList.length; i++) {
        if (this.selectedList[i].id == dataListPermission.id) {
          found = true;
          break;
        }
      }
      return !found;
    });
  }

  onFilterFeaturesSelected() {
    const filterWordsSelected = this.filterWordsSelected.toLowerCase().trim();
    // Get new dataList according to filterWordsSelected
    this.selectedList = this.originalDataList.filter((dataPermission) => {
      return this.commonService.checkFilterWords(dataPermission.name.toLowerCase(), filterWordsSelected);
    });
    // Remove items which are exist in this.dataList
    this.selectedList = this.selectedList.filter(dataListPermission => {
      let found = false;
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id == dataListPermission.id) {
          found = true;
          break;
        }
      }
      return !found;
    });
  }

  moveClick() {
    for (let item of this.leftList) {
      this.dataList.splice(this.dataList.indexOf(item), 1);
      this.selectedList.push(item);
    }
    this.leftList = [];
  }

  returnClick() {
    for (let item of this.rightList) {
      this.selectedList.splice(this.selectedList.indexOf(item), 1);
      this.dataList.push(item);
    }
    this.rightList = [];
  }

  moveAllClick() {
    this.isFormChanging = true;
    if (!this.selectedList) {
      this.selectedList = this.dataList.slice();
    } else {
      let i;
      for (i = 0; i < this.dataList.length; i++) {
        this.selectedList.push(this.dataList[i]);
      }
    }
    this.dataList.splice(0);
    this.leftList = [];
  }

  returnAllClick() {
    this.isFormChanging = true;
    if (!this.dataList) {
      this.dataList = this.selectedList.slice();
    } else {
      let i;
      for (i = 0; i < this.selectedList.length; i++) {
        this.dataList.push(this.selectedList[i]);
      }
    }
    this.selectedList.splice(0);
    this.rightList = [];
  }

  getIndex(i) {
    let idx = this.leftList.indexOf(i);
    if (idx >= 0) {
      this.leftList.splice(idx, 1);
    } else {
      this.leftList.push(i);
    }
  }

  getReturnIndex(i) {
    let idx = this.rightList.indexOf(i);
    if (idx >= 0) {
      this.rightList.splice(idx, 1);
    } else {
      this.rightList.push(i);
    }
  }

  /**
   * On submit form
   */
  onClickBtnSubmit() {
    if (this.selectedBranch == null || this.selectedBranch == undefined || this.selectedBranch.name.trim().length === 0) {
      this.user.enterpriseId = '';
    } else if (this.selectedBranch != null && this.selectedBranch != undefined || this.selectedBranch.name.trim().length === 0) {
      this.user.enterpriseId = this.selectedBranch.id;
    }
  }

  /**
   * Close adding branch dialog
   */
  onNoClick() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  getDepartments() {
    this.departmentService.getAllDepartment().subscribe(res => {
      if (res.success) {
        this.listDepartment = res.data;
        this.listDepartmentFilter = this.listDepartment;
      }
    });
  }

  getDepartmentByEnterpriseId(enterpriseId){
    this.departmentService.getDepartmentByUserEnterprise(enterpriseId).subscribe(res=>{
      if (res.success) {
        this.listDepartment = res.data;
        this.listDepartmentFilter = this.listDepartment;
      }
    })
  }

  onInputChange(event: any) {
    const searchInput = event.target.value.toLowerCase();

    this.listDepartmentFilter = this.listDepartment.filter((item) => {
      const prov = item.name.toLowerCase();
      if (prov.includes(searchInput)) {
        item.isDeleted = false;
      } else {
        item.isDeleted = true;
      }
      return item;
    });
  }
  onInputCertificateChange(event: any) {
    const searchInput = event.target.value.trim().toLowerCase();

    this.listCertificateFilter = this.listCertificate.filter((item) => {
      const prov = item.name.toLowerCase();
      if (prov.includes(searchInput)) {
        return item;
      }
    });
  }
  clearCerNo() {
    this.user.certificateNo='';
  }
}
